import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "../Loader";
import { searchByCustomerName } from "../../api/Sellings.service";

const AllSell = () => {

  const [allSells, setAllSells] = useState([]);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //for displaying buttons
  const [paginateButtons, setPaginateButtons] = useState(false);

  const [loading, setloading] = useState(true)

  const [overallTotal, setOverallTotal] = useState(0);

  const { user } = useSelector(state => state.user);

  const getAllSells = async () => {
    try {
      let response;
      setloading(true);
      response = await axios.get(`/sell/all/paginated?page=${page}`);
      if (response.data.success) {
        setAllSells(response.data.sellings);
        setTotalPages(response.data.totalPages);
        setloading(false);
        response.data.totalPages > 1 ? setPaginateButtons(true) : setPaginateButtons(false);
      }

    } catch (error) {
      setloading(false);
      toast.error(error.response.data.message);
    }
  }

  useEffect(() => {
    getAllSells();
  }, [page]);

  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  }

  const handleNext = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  }

  const [search, setSearch] = useState("")
  //Searching sells by cutomer names
  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      if (search === "") {
        await getAllSells();
      }
      else {
        const data = await searchByCustomerName(search);
        if (data.success) {
          setAllSells(data.sellings);
        }
      }

    } catch (error) {
      setAllSells([]);
    }
  }

  const [selectedDate, setSelectedDate] = useState("");

  const handleDateChange = async (e) => {
    //if there is no search date
    setSelectedDate(e.target.value);
    if (e.target.value === "") {
      getAllSells();
    }

    try {
      const response = await axios.get(`/sell/search/date?date=${e.target.value}`);
      if (response.data.success) {
        setAllSells(response.data.sellings);
        setDateFilteredData(response.data.sellings);
      }
    } catch (error) {

    }
  }

  //calculation of grand total price of overall records
  useEffect(() => {
    let grandTotal = 0;
    allSells?.forEach((p) => {
      grandTotal = grandTotal + p.totalAmount;
    })
    setOverallTotal(grandTotal);
  }, [allSells])


  //filter by payment method
  const [dateFilteredData, setDateFilteredData] = useState([]);
  const filterByPaymentMethod = async (e) => {

    if (selectedDate !== "") {
      setAllSells(dateFilteredData.filter((s) => {
        return s.paymentMethod === e.target.value
      }))
    }
    else {
      try {
        setDateFilteredData([]);
        const response = await axios.get(`/sell/search/paymentMethod/${e.target.value}`);
        if (response.data.success) {
          setAllSells(response.data.sellings);
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
  }

  //Loader.....
  if (loading) {
    return (
      <>
        <Loader />
      </>
    )
  }



  return (
    <>
      <div className="overflow-x-auto mt-5">
        <div className="flex justify-center items-center gap-5">
          <div>
            <input onChange={handleDateChange} type="date" name="date" className="border-2 border-solid border-black p-2 rounded-2xl" />
          </div>

          <div className="">
            <form onSubmit={handleSearch}>
              <input
                type="search"
                placeholder="Search by Customer"
                onChange={(e) => setSearch(e.target.value)}
                className="w-[20vw] h-12 p-4 rounded-lg border-2 border-blue-600 focus:border-none"
              />
              <button className='ml-2 bg-blue-700 text-white font-bold w-20 h-12 rounded-lg'>Search</button>

            </form>

          </div>
          <div>
            <select name="paymentMethod" onChange={filterByPaymentMethod}
              className="select select-info block w-full ">
              <option selected>Select Payment Method</option>
              <option value="CASH">CASH</option>
              <option value="CARD">CARD</option>
              <option value="UPI">UPI</option>
              <option value="NEFT">NEFT</option>
            </select>

          </div>
        </div>


        {true ?
          <>
            <table className="table w-[95%] mx-auto mt-7 overflow-auto">
              <thead className="bg-blue-800 text-white">
                <tr className="text-lg">
                  <th></th>
                  <th className="text-lg font-bold">Date</th>
                  <th className="text-lg font-bold">Customer name</th>
                  {/* <th className="text-lg font-bold text-black">Category</th> */}
                  <th className="text-lg font-bold">Products</th>
                  <th className="text-lg font-bold">Total Amount</th>
                  <th className="text-lg font-bold">Payment Method</th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="border-2 border-blue-400">
                {allSells?.length > 0 &&
                  <>
                    {allSells?.map((sell, index) => {
                      return (
                        <>
                          <tr className="text-base cursor-pointer hover:bg-blue-100">
                            <td className="text-black font-bold">
                              {index + 1}
                            </td>
                            <td className=" text-blue-700 font-bold">
                              {new Date(sell?.date).toLocaleDateString("en-GB")}
                            </td>
                            <td className=" text-blue-700 font-bold">
                              {sell?.customer?.name}
                            </td>
                            {/* <td className="text-lg text-blue-700 font-bold">
                          {sell?.category?.title}
                        </td> */}


                            <td className=" text-blue-700 font-bold">
                              {sell?.products?.length}
                            </td>
                            <td className=" text-blue-700 font-bold">
                              {sell?.totalAmount?.toLocaleString("en-IN")}
                            </td>
                            <td className=" text-blue-700 font-bold">
                              {sell?.paymentMethod}
                            </td>

                            <td className=" text-blue-700 font-bold">
                              <button
                                onClick={() => navigate(`/sold-data/${sell._id}`)}
                                className="btn btn-primary text-white hover:scale-110">
                                More details
                              </button>
                            </td>
                          </tr>

                          {/* row 1 */}


                        </>
                      );
                    })}

                    {
                      overallTotal &&
                      <tr className="text-2xl text-red-700 font-bold bg-red-200 border-2 border-red-600">
                        <td>Grand Total: </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-2xl text-red-700 font-bold">{overallTotal?.toLocaleString("en-IN")}/-</td>
                        <td></td>
                        <td></td>
                      </tr>
                    }
                  </>}


              </tbody>
            </table>

            {paginateButtons ?
              <>
                <div className="h-20 flex justify-center items-center">
                  <button onClick={handlePrevious} className="btn btn-success text-white font-bold" disabled={page === 1}>Previous</button>
                  <span className="bg-blue-500 mx-3 p-4 rounded text-white font-bold">Page {page} of {totalPages}</span>
                  <button onClick={handleNext} className="btn btn-success text-white font-bold" disabled={page === totalPages}>Next</button>
                </div>
              </>
              :
              null
            }

          </>
          : null}
      </div>
    </>
  );
};

export default AllSell;
